import React, { useState, useEffect, useCallback } from "react";
import { Configurations } from "../../../Utils/Configurations";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import './Cile-Content.scss';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import ImagemFukyo from "../../../Components/Imagem-Fukyo/Imagem-Fukyo";
import { SingleDatePicker } from "react-dates";
import moment from "moment";

const CileContentBooksDetails = (props) => {

    const [loadingInfos, setLoadingInfos] = useState(false)
    const [loadingLivros, setLoadingLivros] = useState(true)
    const [loadingCategorias, setLoadingCategorias] = useState(true)
    const [livro, setLivro] = useState()
    const [modalCategoriaSuccess, setModalCategoriaSuccess] = useState(false)
    const [modalInfosSuccess, setModalInfosSuccess] = useState(false)
    const [categorias, setCategorias] = useState([])
    const [listaCategorias, setListaCategorias] = useState()
    const [exibeSelect, setExibeSelect] = useState(false)
    const [idClicado, setIdClicado] = useState()
    const [loadingSalvar, setLoadingSalvar] = useState(false)
    const [imagem, setImagem] = useState()
    const [btnSalvar, setBtnSalvar] = useState(false)
    const [tittleDelete, setTittleDelete] = useState('')
    const [focused, setFocused] = useState(false);
    const [data, setData] = useState(null);
    const [inicialState, setInicialState] = useState({
        sinopse: '',
        link: '',
        data: '',
    });

    const bookId = props.match.params.idLivro ? props.match.params.idLivro : ''
    const _outsideRange = () => false;

    const [formState, setFormState] = useState({
        sinopse: '',
        idCategoria: '',
        idLivro: '',
        url: '',
        categorias: '',
        image: ''
    })

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
        chamadaLivro()
    }, [])

    const chamadaLivro = () => {
        setLoadingLivros(true)
        const config = new Configurations();
        axios.get(config.apiBasePath + `/conteudo-cile/livros/detalhes/${bookId}`)
            .then(response => {
                setLivro(response.data.livro)
                setData(response.data.livro.published_at)
                setFormState((prevState) => ({
                    ...prevState,
                    sinopse: response.data.livro.synopsis,
                    url: response.data.livro.ecommerce_url,
                    categorias: response.data.livro.categories,
                    image: response.data.livro.image
                }));
                setInicialState({
                    sinopse: response.data.livro.synopsis,
                    link: response.data.livro.ecommerce_url,
                    data: response.data.livro.published_at,
                });
                chamadaCategorias()
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {

            });
    }
    const chamadaCategorias = () => {
        setLoadingCategorias(true)
        const config = new Configurations();
        axios.get(config.apiBasePath + `/conteudo-cile/categorias/lista`)
            .then(response => {
                setCategorias(response.data.categorias)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {

            });
    }

    const comparaCategoria = () => {
        let categoriasArr = formState.categorias.split(",").map(id => id.trim());
        setListaCategorias(categorias.filter(i => categoriasArr.includes(String(i.id))))
    }

    const selectLivro = (id) => {
        setFormState((prevState) => ({
            ...prevState,
            idCategoria: id,
        }));
    };


    const adicionarCategoria = () => {
        const config = new Configurations();
        setLoadingCategorias(true)

        const _body = {
            "idLivro": livro.id,
            "idCategoria": parseInt(formState.idCategoria),
            "acao": 'cadastrar'
        };

        axios.post(config.apiBasePath + `/conteudo-cile/categorias/vinculo-livro`, _body)
            .then(response => {
                setFormState((prevState) => ({
                    ...prevState,
                    categorias: response.data.vinculosCategoriaLivro[0].categories
                }));

            }).catch(error => {
                console.log("ERROR: ", error)
            })
    }

    const excluirCategoria = (id) => {
        const config = new Configurations();
        setLoadingCategorias(true)

        const _body = {
            "idLivro": livro.id,
            "idCategoria": id,
            "acao": 'excluir'
        };

        axios.post(config.apiBasePath + `/conteudo-cile/categorias/vinculo-livro`, _body)
            .then(response => {
                setFormState((prevState) => ({
                    ...prevState,
                    categorias: response.data.vinculosCategoriaLivro[0].categories
                }));

            }).catch(error => {
                console.log("ERROR: ", error)
            })
    }

    const editarInfo = (modal) => {
        const config = new Configurations();
        setLoadingInfos(true)

        const _body = {
            "sinopse": formState.sinopse || '',
            "ecommerceUrl": formState.url || '',
            "publishedAt": moment(data).format(),
        };

        axios.put(config.apiBasePath + `/conteudo-cile/livros/atualiza/${livro.id}`, _body)
            .then(() => {
                setLoadingInfos(false)
                if (modal) {
                    setModalInfosSuccess(true)
                }
            }).catch(error => {
                console.log("ERROR: ", error)
            })
    }

    const toggleModalCategoria = () => {
        setModalCategoriaSuccess(!modalCategoriaSuccess)
        setLoadingCategorias(false)
    }

    const toggleModalInfos = () => {
        setModalInfosSuccess(!modalInfosSuccess)
        setLoadingInfos(false)
    }

    const onSelectFileImage = (e) => {
        setImagem(e.target.files[0])
        setBtnSalvar(true)
    }

    const salvarImg = async () => {
        const config = new Configurations();
        var bodyFormData = new FormData();
        bodyFormData.append('imagem', imagem);
        bodyFormData.append('tipo', 'imagens');
        bodyFormData.append('nomeImagem', formState.image);

        setLoadingSalvar(true)

        await axios.post(config.apiBasePath + `/cile/imagem/upload`, bodyFormData)

            .then(response => {
                setFormState((prevState) => ({
                    ...prevState,
                    image: response.data.nameImage,
                }));
                setLoadingSalvar(false)
                setBtnSalvar(false)
                editarInfo(false)

            }).catch(err => {
                console.log("ERROR:", err)
                setLoadingSalvar(false)
            });
    }

    const onDateChange = useCallback((date) => {
        setData(
            date && moment.isMoment(date) ? date : (date ? moment(date) : null)
        );
    }, []);

    const changeStatusColor = (status) => {
        let textColor = 'text-white'
        switch (status) {
            case 'Disponível':
                return { bg: 'success', text: textColor };
            case 'Agendado':
                return { bg: 'info', text: textColor };
            case 'Indisponível':
                return { bg: 'secondary', text: textColor };
            case 'Não agendado':
                return { bg: 'warning', text: 'cinzaRD' };
            default:
                return { bg: 'info', text: textColor };
        }
    }

    const alteraStatus = (item, acao) => {
        const config = new Configurations();
        axios.post(config.apiBasePath + `/conteudo-cile/livros/status/${item.id}/${acao}`)
            .then(() => {
                chamadaLivro()
            })
            .catch(error => {
                console.log("ERROR: ", error)
            });
    }

    const podeSalvar = () => {
        if (inicialState.sinopse !== formState.sinopse || inicialState.link !== formState.url || inicialState.data !== data) {
            return true;
        }
        return false;
    }

    useEffect(() => {
        if (livro && categorias) {
            comparaCategoria()
        }
    }, [categorias, formState.categorias])

    useEffect(() => {
        if (listaCategorias) {
            setLoadingCategorias(false)
            setLoadingLivros(false)
            setExibeSelect(false)
        }
    }, [listaCategorias])
    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-4 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">CILE - Livro</h2>
                        </div>
                        <div className="col-12 col-lg-4 text-center d-flex align-items-center justify-content-center">
                            {loadingLivros ?
                                <div className="spinner-border text-success ml-2" role="status" /> :
                                <>
                                    <h5 className="m-0">Status:
                                        <span className={`text-${changeStatusColor(livro.statusPublicacao).text} mx-1 badge bg-${changeStatusColor(livro.statusPublicacao).bg}`}>{livro && livro.statusPublicacao}</span>
                                    </h5>
                                    {livro.visible ?
                                        <button className='btn btn-outline-danger btn-sm ml-3' disabled={podeSalvar()} onClick={() => alteraStatus(livro, 'desativar')} >
                                            Desativar
                                        </button>
                                        :
                                        <button className='btn btn-outline-success btn-sm ml-3' disabled={podeSalvar()} onClick={() => alteraStatus(livro, 'publicar')} >
                                            Publicar
                                        </button>
                                    }
                                </>
                            }
                        </div>
                        <div className="col-12 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row no-gutters">
                <div className="col-12 col-lg-8">
                    <div className="card mx-1">
                        {loadingLivros ? <div className="spinner-border text-success" role="status" /> :
                            <div className="row no-gutters px-3">
                                <div className="col-12 col-lg-6">
                                    <h4 className="title-1 my-3 pl-3">Detalhes do livro</h4>
                                </div>
                                <div className="col-12 col-lg-6 d-flex align-items-center justify-content-end">
                                    {podeSalvar() ? <p className="text-danger mt-3"><i>As alterações ainda não foram salvas.</i></p> : null}
                                </div>
                                <div className="col-12 col-lg-3 d-lg-block p-3 overflow-hidden ">
                                    <p><strong>Capa atual</strong></p>
                                    <ImagemFukyo
                                        className={`img img-fluid`}
                                        src={livro ? `https://api.ciledigital.com.br/file/images/${livro.image}` : ''}
                                        alt={`imagem-destaque`}
                                    />
                                    <label className="pl-2 pt-3"><strong>Alterar imagem:</strong></label>
                                    <input type="file" accept=".jpg,.jpeg,.png" className="pb-3" onChange={onSelectFileImage} />

                                    {btnSalvar ?
                                        loadingSalvar ?
                                            <div className="spinner-border text-success" role="status" />
                                            : <button onClick={() => salvarImg()} className="btn btn-outline-success pl-3">salvar imagem</button>
                                        : null}

                                </div>
                                <div className="col-12 col-lg-9">
                                    <div className="row no-gutters px-3">
                                        <div className='col-12 pt-3'>
                                            <label className="pl-2"><strong>Título:</strong></label>
                                            <p className="pl-2">{livro.title}</p>
                                        </div>
                                        {livro.subtitle && (
                                            <div className='col-12'>
                                                <label className="pl-2"><strong>Subtítulo:</strong></label>
                                                <p className="pl-2">{livro.subtitle}</p>
                                            </div>
                                        )}
                                        <div className="col-12 col-lg-10">
                                            <label className="pl-2 mr-2"><strong>Data de Publicação:</strong></label>
                                            <div className="pl-2 w-50">
                                                <SingleDatePicker
                                                    date={data ? (moment.isMoment(data) ? data : moment(data)) : null}
                                                    onDateChange={onDateChange}
                                                    focused={focused}
                                                    onFocusChange={({ focused }) => setFocused(focused)}
                                                    id="dtlancamento"
                                                    verticalHeight={450}
                                                    numberOfMonths={1}
                                                    small={true}
                                                    isOutsideRange={_outsideRange}
                                                    placeholder=""
                                                    block={true}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-12 col-lg-2'>
                                            <label className="pl-2"><strong>ID: </strong></label>
                                            <p className="m-0 pl-2">{livro && livro.id}</p>
                                        </div>
                                        <div className="col-12 py-3">
                                            <label className="pl-2"><strong>Sinopse:</strong></label>
                                            <textarea name="sinopse" rows={5} className="w-100 form-control" value={formState.sinopse} onChange={handleInputChange} />
                                        </div>
                                        <div className="col-12 mb-5">
                                            <label className="pl-2"><strong>Link E-commerce:</strong></label>
                                            <input name="url" type="text" className="form-control" autoComplete="off" value={formState.url} onChange={handleInputChange} required={true} />
                                        </div>

                                        <div className="row no-gutters w-100">
                                            <div className='col-12 btn-salvar text-right py-2'>
                                                {loadingInfos ? <div className="spinner-border text-success" role="status" />
                                                    :
                                                    <button className='btn btn-outline-success' onClick={() => editarInfo(true)}>
                                                        Salvar
                                                    </button>
                                                }

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="col-12 col-lg-4">
                    <div className="card mx-1">

                        <div className="row no-gutters px-3">
                            <div className="col-12">
                                <h4 className="title-1 my-3 pl-2">Categorias</h4>
                            </div>
                            <div className="col-12 d-flex align-items-center justify-content-center">
                                <div className="row no-gutters">

                                    {exibeSelect ?
                                        <>
                                            <div className="col-12 mt-3">
                                                <select
                                                    id="idCategoria"
                                                    name="selectLivro"
                                                    className="form-control"
                                                    value={formState.idCategoria}
                                                    onChange={(e) => selectLivro(e.target.value)}
                                                >
                                                    <option value="" disabled hidden>Selecione uma categoria</option>
                                                    {categorias && categorias.length > 0 &&
                                                        categorias.map((item) => (
                                                            <option key={item.id} value={item.id}>
                                                                {item.category}
                                                            </option>
                                                        ))
                                                    }

                                                </select>
                                            </div>
                                            <div className="row no-gutters w-100">
                                                <div className='col-12 text-center py-2 mt-3'>
                                                    <button className='btn btn-outline-success' onClick={() => adicionarCategoria()}>
                                                        Salvar
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <div className="row no-gutters w-100">
                                            <div className='col-12 text-center py-2'>
                                                <button className='btn btn-outline-primary' onClick={() => setExibeSelect(true)}>
                                                    Adicionar categoria
                                                </button>
                                            </div>
                                        </div>
                                    }

                                </div>
                            </div>
                            <div className="col-12 my-3">
                                <div className="row no-gutters px-3">

                                    <label className=" mt-2"><strong>Lista:</strong></label>

                                    {listaCategorias && listaCategorias.map((item, index) => (
                                        <>
                                            <div className="row no-gutters w-100 pt-3 d-flex justify-content-between align-items-center">
                                                <p className="m-0">{item.category}</p>
                                                {loadingCategorias && idClicado === item.id ? <div className="spinner-border spinner-border-sm text-danger text-center" role="status" /> :
                                                    <button className='btn btn-outline-danger btn-sm mb-1' key={item.id} onClick={() => toggleModalCategoria() + setIdClicado(item.id) + setLoadingCategorias(true) + setTittleDelete(item.category)}>
                                                        Remover
                                                    </button>
                                                }
                                            </div>
                                        </>
                                    ))}
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>



            {/* AJUSTAR O LAYOUT DO MODAL PARA O PADRÃO */}
            <Modal isOpen={modalCategoriaSuccess} toggle={toggleModalCategoria}>
                <ModalBody>
                    <div className='row'>
                        <div className='col-12'>
                            <p>Deseja excluir a categoria <b>{tittleDelete}</b>?</p>
                        </div>
                        <div className='col-6 text-center pt-2'>
                            <button className='btn btn-outline-primary' onClick={() => toggleModalCategoria()} >
                                Cancelar
                            </button>
                        </div>
                        <div className='col-6 text-center pt-2'>
                            <button className='btn btn-outline-danger' onClick={() => excluirCategoria(idClicado) + toggleModalCategoria()} >
                                Excluir
                            </button>
                        </div>

                    </div>

                </ModalBody>
            </Modal>

            <Modal isOpen={modalInfosSuccess} toggle={toggleModalInfos}>
                <ModalHeader toggle={toggleModalInfos}>
                    Informações do livro
                </ModalHeader>
                <ModalBody>
                    Alterações realizadas com sucesso!
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={() => { toggleModalInfos(); window.history.go(-1); }}>ok</Button>
                </ModalFooter>
            </Modal>


        </div >
    )
}


export default withRouter(CileContentBooksDetails);